<template>
  <div>
    <!-- <Top></Top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img v-lazy="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">星辰云货架</div>
          <div class="contentBottom">
            <div>打破空间局限 汇聚海量商品</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="topText">
      创造无感式购物体验，通过采集消费者用户身份，利用合理消费行为触发产品功能卖点展示，打通线上数据库，在面积有限的实体门店，销售无限的全渠道SKU。
    </div>

    <!-- start -->
    <div class="contentFlex">
      <div class="contentBox">
        <img v-lazy="wawa1" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa2" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa3" alt>
      </div>
      <div class="contentBox">
        <img v-lazy="wawa4" alt>
      </div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="titleBox">
      <div class="anliTitle">适用行业</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- iconFlex start -->
    <div class="iconParent">
      <div class="iconFlex">
        <div class="iconBox">
          <img v-lazy="wawaIcon1" alt>
          <div class="iconText">零售</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon2" alt>
          <div class="iconText">服装</div>
        </div>
        <div class="iconBox">
          <img v-lazy="wawaIcon3" alt>
          <div class="iconText">图书</div>
        </div>
      </div>
    </div>
    <!-- iconFlex end -->
    <!-- 产品特色 start -->
    <!-- start -->
    <div class="titleBox" style="margin-top:140px">
      <div class="anliTitle">产品特色</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <div class="teSeParent">
      <div class="teSeLeft">
        <img v-lazy="teSeImg1" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">无感式用户体验</div>
        <div class="teSeText">顾客在操作的过程中，设备搭载的数拓综合传感器会描绘用户画像，根据顾客身份潜移默化的把合适的产品呈现用户眼前。</div>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft teSeLeftTwo">
        <div class="teSeTitle">海量SKU聚合</div>
        <div class="teSeText">
          摆脱实体店空间的限制，顾客可以在实体店体验到品牌海量的云端产品。帮助品牌释放产品能量的同事，为顾客提供了无限的选择空间。
        </div>
      </div>
      <div class="teSeRight teSeRightTwo">
        <img v-lazy="teSeImg2" class="teSeImg" alt>
      </div>
    </div>
    <div class="teSeParent">
      <div class="teSeLeft">
        <img v-lazy="teSeImg3" class="teSeImg" alt>
      </div>
      <div class="teSeRight">
        <div class="teSeTitle">特色产品感知推荐</div>
        <div class="teSeText">品牌可为实体店内核心产品搭载小型硬件，当顾客拿起产品浏览时，星辰云货架显示该产品更为丰富产品介绍，帮助顾客深入了解。</div>
      </div>
    </div>

    <!-- 管理平台 start -->
    <!-- start -->
    <div class="titleBox marginTop142">
      <div class="anliTitle">技术优势</div>
      <div class="lineCss"></div>
    </div>
    <!-- end -->
    <!-- start -->
    <div class="imgBox minimgBox">
      <div class="imgLeft positionBoxParent">
        <img v-lazy="MPDPImgLeft4" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">商品对接</div>
          <div class="positionText">商品来源的灵活对接</div>
        </div> -->
      </div>
      <div class="imgRight textRight positionBoxParent">
        <img v-lazy="MPDPImgRight4" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">感应接入</div>
          <div class="positionText">
            支持接入蓝牙／rfid／NFC等
            <br>智能外设，实现感应识别交互
          </div>
        </div> -->
      </div>
    </div>
    <div class="imgBox minimgBox">
      <div class="imgLeft positionBoxParent">
        <img v-lazy="storageBottom3" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">数据回流</div>
          <div class="positionText">交互数据统计回流。提供营销指导</div>
        </div> -->
      </div>
      <div class="imgRight textRight positionBoxParent">
        <img v-lazy="storageBottom4" alt class="imgSmallImg">
        <!-- <div class="positionBox">
          <div class="positionTitle">时光沙漏</div>
          <div class="positionText">时光沙漏产品对比</div>
        </div> -->
      </div>
    </div>
    <!-- end -->
    <!-- 管理平台 end -->
    <!-- 产品特色 end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/storageTop.png";
import wawa1 from "@/assets/images/storage1.png";
import wawa2 from "@/assets/images/storage2.png";
import wawa3 from "@/assets/images/storage3.png";
import wawa4 from "@/assets/images/storage4.png";

import wawaIcon1 from "@/assets/images/storageIcon1.png";
import wawaIcon2 from "@/assets/images/storageIcon2.png";
import wawaIcon3 from "@/assets/images/storageIcon3.png";

import teSeImg1 from "@/assets/images/storageImg1.png";
import teSeImg2 from "@/assets/images/storageImg2.png";
import teSeImg3 from "@/assets/images/storageImg3.png";

import adminImg1 from "@/assets/images/wawaBottom1.png";
import adminImg2 from "@/assets/images/wawaBottom2.png";
import adminImg3 from "@/assets/images/wawaBottom3.png";

import MPDPImgLeft4 from "@/assets/images/storageFu1.png";
import MPDPImgRight4 from "@/assets/images/storageFu2.png";
import storageBottom3 from "@/assets/images/storageFu3.png";
import storageBottom4 from "@/assets/images/storageFu4.png";
import Bread from "@/components/bread.vue";
export default {
  name: "ProductStorage",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      toBreadChild: ["产品", "星辰云货架"],
      bgImg: bgImg,
      wawa1: wawa1,
      wawa2: wawa2,
      wawa3: wawa3,
      wawa4: wawa4,
      wawaIcon1: wawaIcon1,
      wawaIcon2: wawaIcon2,
      wawaIcon3: wawaIcon3,
      storageBottom3: storageBottom3,
      storageBottom4: storageBottom4,
      teSeImg1: teSeImg1,
      teSeImg2: teSeImg2,
      teSeImg3: teSeImg3,
      adminImg1: adminImg1,
      adminImg2: adminImg2,
      adminImg3: adminImg3,
      MPDPImgLeft4: MPDPImgLeft4,
      MPDPImgRight4: MPDPImgRight4
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
.topText {
  width: 60%;
  margin: auto;
  max-width: 890px;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 74px;
  margin-bottom: 80px;
}

/* start */
.anliTitle {
  font-size: 4rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 179px;
}

/* end */
.contentFlex {
  width: 70%;
  margin: auto;
  display: flex;
  justify-content: space-around;
}
.contentBox {
  width: 25%;
  text-align: center;
}
.contentBox img {
  width: 90%;
  max-width: 255px;
  margin: auto;
}
.iconParent {
  background: rgba(238, 238, 238, 1);
  margin-top: 56px;
}
.iconFlex {
  display: flex;
  width: 70%;
  margin: auto;
  padding: 84px 0 60px;
}
.iconBox {
  width: 33%;
  text-align: center;
}
.iconBox img {
  width: 80%;
  max-width: 96px;
}
.iconText {
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);

  margin-top: 10px;
}
.teSeParent::after {
  content: "";
  display: block;
  clear: both;
}
.teSeParent {
  width: 70%;
  margin: auto;
  margin-top: 75px;
}
.teSeLeft {
  width: 50%;
  float: left;
}
.teSeRight {
  width: 42%;
  float: right;
}
.teSeImg {
  width: 100%;
  /* max-width: 769px;  */
}
.teSeTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  margin-top: 20%;
}
.teSeText {
  width: 86%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 10%;
  line-height: 30px;
}
.teSeLeftTwo {
  width: 42%;
  padding-left: 6.5%;
}
.teSeRightTwo {
  width: 50%;
}
.imgBox {
  width: 70%;
  margin: auto;
}
.imgBox::after {
  content: "";
  display: block;
  clear: both;
}
.imgLeft {
  width: 49%;
  float: left;
}
.imgRight {
  width: 49%;
  float: right;
  text-align: right;
}
.imgXiaImg {
  width: 100%;
  max-width: 584px;
}
.marginTop2 {
  margin-top: 2%;
}
.spicial {
  background: #eeeeee;
  margin-top: 54px;
}
.positionBoxParent {
  position: relative;
}
.positionBox {
  position: absolute;
  bottom: 15px;
  text-align: center;
  width: 370px;
  left: calc(50% - 185px);
}
.positionTitle {
  font-size: 2.2rem;
  font-family: PingFangSC-Regular;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
  line-height: 33px;
}
.positionText {
  font-size: 2rem;
  font-family: PingFangSC-Light;
  font-weight: bold;
  color: rgba(106, 106, 106, 1);
}
.imgSmallImg {
  width: 80%;
  /* max-width: 481px; */
  margin-top: 49px;
}
.minimgBox {
  /* min-width: 886px; */
}
</style>



// WEBPACK FOOTER //
// src/view/ProductStorage.vue